var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"max-height":"100%"}},[_c('navigation-tab',{attrs:{"items":_vm.items}}),_c('router-view',{on:{"reload":_vm.updateTabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }